import RoutesGAC from "./router/routes";
import "./styles/index.css";

function App() {
  return <RoutesGAC />;
}

export default App;
